export const UPDATE_APPLICATIONS = 'UPDATE_APPLICATIONS';
export const SET_APPLICATIONS = 'SET_APPLICATIONS';
export const ADD_APPLICATION = 'ADD_APPLICATION';
export const UPDATE_ASSIGNEE = 'UPDATE_ASSIGNEE';
export const SET_APPLICATION = 'SET_APPLICATION';
export const UPDATE_APPLICATION_ON_MOVE = 'UPDATE_APPLICATION_ON_MOVE';
export const SET_UNSEEN_COUNT = 'SET_UNSEEN_COUNT';
export const UPDATE_APP_LOGBOOK = 'UPDATE_APP_LOGBOOK';
export const ADD_REVIEW_TO_APP = 'ADD_REVIEW_TO_APP';
export const ALL_MEMBERS = 'ALL_MEMBERS';
export const CURRENT_ASSIGNEE = 'CURRENT_ASSIGNEE';
export const SET_BTN_LOADER = 'SET_BTN_LOADER';
export const SET_LOGBOOK_COMMENT_RES = 'SET_LOGBOOK_COMMENT_RES';
export const SET_SNACKBAR_STATE_FOR_TASK_BOARD =
  'SET_SNACKBAR_STATE_FOR_TASK_BOARD';
